// ============================================================
// Reserved Area — AJAX download listing
// ============================================================

// State ---------------------------------------------------
let currentTermId    = null;
let currentOffset    = 0;
let currentOrderby   = 'post_title';
let currentOrder     = 'ASC';
let currentTotal     = 0;
const LOAD_MORE_STEP = 10;

/**
 * Active filters passed to every AJAX request.
 * Add new filter keys here as needed (e.g. family: '') — loadDownloadAjax
 * will automatically include them in the request body without any signature
 * change. Callers that change a specific filter only update that key and call
 * loadDownloadAjax; category navigation resets the whole object.
 */
let currentFilters = {
	search: '',
};

// DOM references ------------------------------------------
const downloadsList    = document.getElementById('downloads-list');
const loadMoreBtn      = document.querySelector('.load-more');
const archiveWrapper   = document.querySelector('[data-type="download-archive"]');
const multipleSelector = document.getElementById('multiple-selection');
const pagination       = document.querySelector('.pagination');

// Preserve the original button label for use in the counter.
const loadMoreLabel = loadMoreBtn?.textContent?.trim() || '';

// Hide load-more until first AJAX load confirms there are more pages.
if (loadMoreBtn) 
	loadMoreBtn.style.display = 'none';

// Sort mapping (data-prop attribute → AJAX params) --------
const SORT_MAP = {
	alpha: { orderby: 'post_title', order: 'ASC'  },
	date:  { orderby: 'post_date',  order: 'DESC' },
};

// ============================================================
// Category navigation
// ============================================================

const downloadCategories = document.querySelectorAll('.download-categories > li a');

downloadCategories.forEach((category) => {
	category.addEventListener('click', (e) => {
		e.preventDefault();

		document.querySelector('.download-categories > li .--active')?.classList.remove('--active');
		category.classList.add('--active');

		const categoryId           = category.dataset.categoryId;
		const currentSubcategories = document.querySelector('.download-subcategories.--visible');
		const nextSubcategories    = document.querySelector(
			'.download-subcategories[data-category-parent="' + categoryId + '"]'
		);

		if (categoryId && currentSubcategories) {
			if (currentSubcategories.dataset.categoryParent !== categoryId) {
				gsap.to(currentSubcategories, {
					height: 0,
					duration: 0.3,
					onComplete: () => {
						currentSubcategories.classList.remove('--visible');
						currentSubcategories.classList.remove('--filtered');

						if (nextSubcategories) {
							gsap.to(nextSubcategories, {
								height: 'auto',
								duration: 0.3,
								onComplete: () => nextSubcategories.classList.add('--visible'),
							});
						}
					},
				});
			}
		} else if (nextSubcategories) {
			gsap.to(nextSubcategories, {
				height: 'auto',
				duration: 0.3,
				onComplete: () => nextSubcategories.classList.add('--visible'),
			});
		}

		document.querySelector('.download-search')?.classList.add('--visible');

		// Pre-select the first leaf subcategory; fall back to parent term.
		const firstChild = nextSubcategories?.querySelector(
			'li:not(.--open) > a[data-category-id]'
		);

		if (firstChild) {
			nextSubcategories.classList.add('--filtered');
			firstChild.closest('li').classList.add('--active');

			if ('locked' === firstChild.dataset.categoryStatus) {
				showDownloadMessage();
			} else {
				resetFilters();
				loadDownloadAjax(firstChild.dataset.categoryId, true);
			}
		} else {
			if ('locked' === category.dataset.categoryStatus) {
				showDownloadMessage();
			} else {
				resetFilters();
				loadDownloadAjax(categoryId, true);
			}
		}
	});
});

// Subcategory clicks --------------------------------------

const downloadSubcategories = document.querySelectorAll('.download-subcategories > li a');

downloadSubcategories.forEach((category) => {
	category.addEventListener('click', (e) => {
		const parent     = category.closest('li');
		const subMenu    = parent.querySelector('ul');
		const parentMenu = category.closest('.download-subcategories');

		parentMenu.classList.add('--filtered');

		if (subMenu) {
			e.preventDefault();

			if (parent.classList.contains('--open')) {
				gsap.to(subMenu, { height: 0 });
				parent.classList.remove('--open');
			} else {
				gsap.to(subMenu, { height: 'auto' });
				parent.classList.add('--open');
			}
		} else {
			parentMenu.querySelectorAll('.--active').forEach((item) => item.classList.remove('--active'));

			if ('locked' === category.dataset.categoryStatus) {
				showDownloadMessage();
			} else {
				resetFilters();
				loadDownloadAjax(category.dataset.categoryId, true);
			}
		}

		parent.classList.add('--active');
	});
});

// ============================================================
// Sort filter — server-side sort via AJAX
//
// filters.js also listens on .filter-group and handles the --active
// class update. Our listener triggers the AJAX call; the response
// replaces the DOM with correctly sorted data from the server.
// ============================================================

document.querySelector('#filter-sort')?.addEventListener('click', (e) => {
	const filterItem = e.target.closest('a');

	if (!filterItem || !('prop' in filterItem.dataset)) 
		return;

	const sort = SORT_MAP[filterItem.dataset.prop];

	if (!sort || !currentTermId) 
		return;

	currentOrderby = sort.orderby;
	currentOrder   = sort.order;

	loadDownloadAjax(currentTermId, true);
});

// ============================================================
// AJAX download loader
// ============================================================

/**
 * Loads downloads for a term via AJAX and renders them in #downloads-list.
 *
 * @param {string|number} termId  download_cat term ID
 * @param {boolean}       reset   true = first page (clears list); false = load more (appends)
 */
function loadDownloadAjax(termId, reset) {
	if (!termId || typeof msRaData === 'undefined') 
		return;

	if (reset) {
		currentTermId = termId;
		currentOffset = 0;
		currentTotal  = 0;
	}

	const offset = reset ? 0 : currentOffset;
	const limit  = reset ? 30 : LOAD_MORE_STEP;

	// Loading state.
	if (archiveWrapper) {
		archiveWrapper.style.opacity = '0.4';
		downloadsList.classList.add('loading');
	}

	if (loadMoreBtn) {
		loadMoreBtn.style.display = 'none';
	}

	const body = new URLSearchParams({
		action:  'ms_ra_get_downloads_by_term',
		nonce:   msRaData.nonce,
		term_id: termId,
		offset,
		limit,
		orderby: currentOrderby,
		order:   currentOrder,
		// All active filters are spread here; add new keys to currentFilters
		// and they will automatically be included in every request.
		...currentFilters,
	});

	fetch(msRaData.ajaxUrl, {
		method:  'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		body:    body.toString(),
	})
		.then((res) => res.json())
		.then((response) => {
			if (!response.success) {
				showDownloadMessage();
				return;
			}

			const { items, total } = response.data;

			currentTotal  = total;
			currentOffset = offset + items.length;

			if (reset) {
				downloadsList.innerHTML = '';
				// Reset bulk selection when loading a new term.
				resetBulkSelection();
			}

			if (items.length > 0) {
				items.forEach((item) => {
					downloadsList.insertAdjacentHTML('beforeend', buildItemHTML(item));
				});
			} else {
				showDownloadMessage(mswpt_vars.ra.no_results);
			}

			// Show/hide "Load more" based on whether all items have been fetched.
			if (loadMoreBtn) {
				loadMoreBtn.dataset.offset = currentOffset;
				loadMoreBtn.dataset.total = currentTotal;

				if (currentOffset < currentTotal) {
					// loadMoreBtn.textContent = loadMoreLabel + ' (' + currentOffset + ' / ' + currentTotal + ')';
					loadMoreBtn.style.display = '';
				} else {
					loadMoreBtn.style.display = 'none';
				}
			}

			if (pagination) {
				pagination.textContent = pagination.dataset.textcontent.replaceAll('%offset', currentOffset).replaceAll('%total', currentTotal);
			}

			if (typeof ScrollTrigger !== 'undefined') {
				ScrollTrigger.refresh();
			}
		})
		.catch((err) => console.error('RA download load error:', err))
		.finally(() => {
			if (archiveWrapper) {
				archiveWrapper.style.opacity = '1';
				downloadsList.classList.remove('loading');
			}
		});
}

// Load more -----------------------------------------------

loadMoreBtn?.addEventListener('click', () => {
	if (currentTermId) {
		loadDownloadAjax(currentTermId, false);
	}
});

// ============================================================
// Search filter — server-side via AJAX
// ============================================================

const downloadSearchForm  = document.getElementById('download-search-form');
const downloadSearchInput = document.getElementById('download-search');

downloadSearchForm?.addEventListener('submit', (e) => {
	e.preventDefault();

	if (!currentTermId) 
		return;

	currentFilters.search = (downloadSearchInput?.value || '').trim();
	loadDownloadAjax(currentTermId, true);
});

// ============================================================
// Family filter — client-side 
// ============================================================

const filterGroups = document.querySelectorAll(".filters-panel.ra-filters .filter-group");

filterGroups.forEach((group) => {
	group.addEventListener("click", (evt) => {
		let filterItem = evt.target.closest("a");

		if (!filterItem) 
			return;

		if (!("prop" in filterItem.dataset)) 
			return;

		let filterType = filterItem.dataset.prop;
		let items = Array.from(document.querySelectorAll(".download-grid-items .archive-item"));

		if (filterType != "alpha" && filterType != "date") {
			if (!("val" in filterItem.dataset)) 
				return;

			let filterValue = filterItem.dataset.val;
			let hiddenCount = 0;

			// resetFilters("client");

			// Loading state.
			if (archiveWrapper) {
				archiveWrapper.style.opacity = '0.4';
				downloadsList.classList.add('loading');
			}

			if (loadMoreBtn) {
				loadMoreBtn.style.display = 'none';
			}

			if (pagination) {
				pagination.style.display = 'none';
			}

			items.forEach((item) => {
				const isHidden = filterType === "family"
					? item.dataset[filterType] != filterValue
					: item.dataset[filterType].indexOf(filterValue) < 0;

				if (isHidden) {
					item.classList.add("hidden");
					item.removeAttribute("data-defer");
					hiddenCount++;
				}
			});

			// no results
			if (hiddenCount == items.length) {
				showDownloadMessage(mswpt_vars.ra.no_results, 'add');
			}

			// Fa il refresh di tutti gli scrollTrigger per footer
			setTimeout(() => {
				ScrollTrigger.refresh();
			}, 500);

			initDeferAnimation();
			
			if (archiveWrapper) {
				archiveWrapper.style.opacity = '1';
				downloadsList.classList.remove('loading');

			}
		}

		// Updates selected filter option
		filterItem.closest("li").classList.add("--active");
		filterItem.closest("ul").classList.add("--filtered");
		// Closes filters panel
		document.querySelector(".filters-panel").classList.toggle("--open");
	});
});

const filtersResetButtons = document.querySelectorAll(".ra-filters-reset");

filtersResetButtons?.forEach((elem) => {
	elem.addEventListener("click", (e) => {
		if (!document.querySelector(".filters-panel")) 
			return;

		resetFilters("client");
		e.stopPropagation();

		// if (downloadsList.querySelectorAll(".archive-item").length > 0) {
			
		// } else {
		// 	showDownloadMessage(mswpt_vars.ra.no_results);
		// }
	});
});

/**
 * Resets all active filters and clears their corresponding UI inputs.
 * Call this before loadDownloadAjax when switching categories.
 */
function resetFilters(side = 'server') {
	if ("server" == side) {
		currentFilters = { search: '' };

		if (downloadSearchInput) 
			downloadSearchInput.value = '';
	} else {
		let filterType = "family";

		// Restore all hidden items.
		document.querySelectorAll(".download-grid-items .archive-item.hidden").forEach((item) => {
			item.classList.remove("hidden");
		});

		if (document.getElementById("filter-" + filterType) != null)
			document.getElementById("filter-" + filterType).classList.remove("--filtered");

		if (document.querySelectorAll("#filter-" + filterType + " li.--active").length > 0)
			document.querySelectorAll("#filter-" + filterType + " li.--active").forEach((i) => {
				i.classList.remove("--active");
			});

		if (loadMoreBtn) {
			if (loadMoreBtn.dataset.offset != loadMoreBtn.dataset.total) {
				loadMoreBtn.style.display = '';
			}
		}

		if (document.getElementById('message')) {
			document.getElementById('message').remove();
		}

		if (pagination) {
			pagination.style.display = '';
		}

		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 500);

		// window.scrollTo({ top: 0, behavior: "smooth" });
	}
}

// ============================================================
// Item HTML builder
// Mirrors the structure of template-parts/reserved-area/item.php.
// ============================================================

/**
 * Builds the HTML string for a single download item card.
 *
 * @param {Object} item  Serialized download item from AJAX response
 * @returns {string}
 */
function buildItemHTML(item) {
	const type         = item.type || '';
	const productTypes = item.product_type_names || [];
	const title        = item.label 
		? item.label + ' ' + productTypes.join('/') 
		: item.title;
	const family       = item.product_family_slug || '';
	const format       = item.file_format  || '';
	const sizeKb       = item.file_size_kb || 0;
	const date         = item.modified_date || '';
	const filename     = item.filename || '';

	// Free downloads expose a featured_image; managed use thumbnail_url.
	const thumb        = item.featured_image || item.thumbnail_url || '';

	const isIcon        = ('svg' == thumb.split('.').pop()) ? 'icon' : '';
	const market        = item.market.toUpperCase() || '';
	let marketTag       = '';
	const showMarketTag = '';

	if ('always' == showMarketTag) {
		marketTag = mswpt_vars.ra.market_labels[market]
			? '<span class="badge">' + mswpt_vars.ra.market_labels[market] + '</span>' 
			: '' ;
	} else {
		marketTag = (('us' == mswpt_vars.current_lang && 'USA' != market) || ('us' != mswpt_vars.current_lang && 'USA' == market)) && mswpt_vars.ra.market_labels[market]
			? '<span class="badge">' + mswpt_vars.ra.market_labels[market] + '</span>' 
			: '' ;
	}

	const groupCode = item.group_code ?? '';
	const modelCode = item.model_code ?? '';

	// Data stored in data-json: everything the detail popup needs.
	const json = JSON.stringify({
		id:           item.id,
		title,
		// infos (managed only) shown as "note" in the popup.
		note:         item.infos || '',
		filename,
		filetype:     format,
		filesize:     sizeKb,
		thumbnail:    thumb,
		type:         type,
		market:       market,
		productTypes: productTypes,
		groupCode:    groupCode,
		modelCode:    modelCode,
	});

	const viewToggle = document.querySelector('.controls.switch-view .view-toggle');
	let itemClasses = viewToggle.classList.contains('single') 
		? viewToggle.dataset.singleView 
		: viewToggle.dataset.multipleView;

	return `
	<div class="download-item archive-item ${escAttr(itemClasses)}"
		data-date="${escAttr(date)}"
		data-alpha="${escAttr(title)}"
		data-family="${escAttr(family)}"
		data-filename="${escAttr(filename)}"
		data-filetype="${escAttr(format)}"
		data-filesize="${escAttr(String(sizeKb))}"
		data-json="${escAttr(json)}" data-types="${productTypes.join(' / ')}" 
		data-groupcode="${escAttr(groupCode)}" 
		data-modelcode="${escAttr(modelCode)}">
		<a href="javascript:void(0);" class="flex flex-column align-items-start justify-content-start">
			<div class="thumbnail ${isIcon}">
				<img src="${escAttr(thumb)}" />
			</div>
			<span class="flex flex-column align-items-start"><span>${escHTML(title)} - ${escAttr(modelCode)}</span>${marketTag}</span>
		</a>
		<div class="form-field custom-checkbox">
			<span class="form-control-wrap">
				<span class="form-control checkbox">
					<span class="list-item first last">
						<label>
							<input type="checkbox" name="download_1" data-id="${escAttr(item.id)}" /><span class="list-item-label"></span>
						</label>
					</span>
				</span>
			</span>
		</div>
	</div>`;
}

// ============================================================
// Item detail popup
// ============================================================

downloadsList?.addEventListener('click', (e) => {
	if (e.target.closest('a')) {
		handleItemDetail(e.target);
	} else if (e.target.closest('input[type="checkbox"]')) {
		handleItemSelection();
	}
});

function handleItemDetail(target) {
	const item  = target.closest('.download-item');
	const modal = document.getElementById('download-details');

	if (!item || !modal) 
		return;

	if (modal.classList.contains('--open')) {
		closePanel(modal);
		return;
	}

	const itemData = item.dataset.json ? JSON.parse(item.dataset.json) : {};
	const panel    = modal.querySelector('.download-data');

	if (!panel) 
		return;

	panel.querySelector('.title').innerText    = itemData.title    || '';
	// note may contain HTML (admin-entered rich text in WordPress).
	panel.querySelector('.note').innerHTML     = itemData.note     || '';
	panel.querySelector('.filename').innerText = itemData.filename || '';
	panel.querySelector('.filetype').innerText = itemData.filetype || '';
	panel.querySelector('.filesize').innerText = itemData.filesize || '';
	panel.querySelector('.thumbnail')?.setAttribute('src', itemData.thumbnail || '');

	// Point the download button to the file proxy endpoint.
	if (itemData.id && typeof msRaData !== 'undefined') {
		const proxyUrl = msRaData.ajaxUrl
			+ '?action=ms_ra_download_file'
			+ '&file_id=' + encodeURIComponent(itemData.id)
			+ '&nonce='   + encodeURIComponent(msRaData.nonce);

		panel.querySelector('.fileurl')?.setAttribute('href', proxyUrl);
	}

	openPanel(modal);
}

// ============================================================
// Bulk file selection
// ============================================================

function handleItemSelection() {
	const checked = [
		...(downloadsList?.querySelectorAll('input[type="checkbox"]:checked') || []),
	];
	const count = checked.length;

	let totalKb = 0;

	checked.forEach((cb) => {
		const sizeKb = parseFloat(
			cb.closest('.download-item')?.dataset.filesize || '0'
		);
		totalKb += isNaN(sizeKb) ? 0 : sizeKb;
	});

	const totalMb = (totalKb / 1024).toFixed(2);

	if (!multipleSelector) 
		return;

	multipleSelector.classList.toggle('--active', count > 0);

	const fileCount = multipleSelector.querySelector('#file-count');
	const sizeCount = multipleSelector.querySelector('#size-count');

	if (fileCount) 
		fileCount.innerText = count;

	if (sizeCount) 
		sizeCount.innerText = totalMb;

	// Disable ZIP download button when the size limit is exceeded.
	if (typeof msRaData !== 'undefined') {
		const overLimit  = totalKb > msRaData.maxZipSizeKb;
		const maxMb      = (msRaData.maxZipSizeKb / 1024).toFixed(0);
		const zipBtn     = multipleSelector.querySelector('a.button:not(.reset-selection)');

		if (zipBtn) {
			zipBtn.classList.toggle('--disabled', overLimit);
			zipBtn.setAttribute(
				'title',
				overLimit ? mswpt_vars.ra.zip_errors.maxsize.replace('%s', maxMb) : ''
			);
		}
	}
}

// Reset selection -----------------------------------------

function resetBulkSelection() {
	downloadsList?.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
		cb.checked = false;
	});
	handleItemSelection();
}

multipleSelector?.querySelector('.reset-selection')?.addEventListener('click', () => {
	resetBulkSelection();
});

// ============================================================
// Bulk ZIP download
// ============================================================

multipleSelector?.querySelector('a.button:not(.reset-selection)')?.addEventListener('click', (e) => {
	e.preventDefault();

	if (typeof msRaData === 'undefined') 
		return;

	const zipBtn = e.currentTarget;

	if (zipBtn.classList.contains('--disabled')) 
		return;

	const checked = [
		...(downloadsList?.querySelectorAll('input[type="checkbox"]:checked') || []),
	];

	if (checked.length === 0) 
		return;

	const fileIds = checked.map((cb) => cb.dataset.id).filter(Boolean);

	if (fileIds.length === 0) 
		return;

	// Show loading state on the button.
	zipBtn.classList.add('--loading');
	zipBtn.setAttribute('aria-disabled', 'true');

	const body = new URLSearchParams({ action: 'ms_ra_generate_zip', nonce: msRaData.nonce });
	fileIds.forEach((id) => body.append('file_ids[]', id));

	fetch(msRaData.ajaxUrl, {
		method:  'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		body:    body.toString(),
	})
		.then((res) => res.json())
		.then((response) => {
			if (!response.success) {
				alert(response.data?.message || mswpt_vars.ra.zip_errors.serverside);
				return;
			}

			const { token } = response.data;

			// Redirect the browser to the serve endpoint — triggers the save dialog.
			const serveUrl = msRaData.ajaxUrl
				+ '?action=ms_ra_serve_zip'
				+ '&token=' + encodeURIComponent(token)
				+ '&nonce=' + encodeURIComponent(msRaData.nonce);

			window.location.href = serveUrl;
		})
		.catch((err) => {
			console.error('RA ZIP error:', err);
			alert(mswpt_vars.ra.zip_errors.generic);
		})
		.finally(() => {
			zipBtn.classList.remove('--loading');
			zipBtn.removeAttribute('aria-disabled');
		});
});

// ============================================================
// Helpers
// ============================================================

/**
 * Clears the downloads list and shows a locked/access-denied message.
 * Used when the user clicks a category they cannot access.
 */
function showDownloadMessage(message = '', action = 'replace') {
	const msg = message 
		? message 
		: (typeof msRaData !== 'undefined' && msRaData.lockedMessage)
			? msRaData.lockedMessage
			: mswpt_vars.ra.permissions_error;

	if (downloadsList) {
		if ("replace" == action) {
			downloadsList.innerHTML = `<div class="container --fluid pt-5 pb-5"><p class="h3 text-center">${escHTML(msg)}</p></div>`;
		} else {
			downloadsList.insertAdjacentHTML('afterbegin', `<div id="message" class="container --fluid pt-5 pb-5"><p class="h3 text-center">${escHTML(msg)}</p></div>`);
		}

		if (archiveWrapper) 
			archiveWrapper.style.opacity = '1';
	}

	if (loadMoreBtn) 
		loadMoreBtn.style.display = 'none';

	resetBulkSelection();
}

/** Escapes a value for use inside a double-quoted HTML attribute. */
function escAttr(str) {
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/** Escapes a value for use as HTML text content. */
function escHTML(str) {
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}
